// extracted by mini-css-extract-plugin
export default {"avatar":"Profile-module__avatar___C5ERB","notified":"Profile-module__notified___djfMe"};